<template>
  <span
    class="b1 py-1 px-2 rounded bg-department text-department-contrast"
    :title="t('jc.role.' + props.roleKey + '.description')"
    :class="{
      ['department-' + department.nameKey]: true,
      ['role-' + userRole.nameKey]: true,
    }"
  >
    {{ t('jc.role.' + props.roleKey + '.label') }}
  </span>
</template>

<script setup lang="ts">
import type { UserRole } from '~/composables/charon'
import { UserRoleData, DepartmentData } from '~/composables/charon'

const { t } = useI18n()

const props = defineProps<{
  roleKey: UserRole
}>()

const userRole = computed(() => UserRoleData[props.roleKey])
const department = computed(() => DepartmentData[userRole.value.department])
</script>
